import { Module } from 'vuex'

import { NoticeState, RootState } from '@/types/store'
import { UserRole } from '@/types/user'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: NoticeState = {
  total: 0,
  isNoticesLoading: false,
  notice: {
    id: -1,
    title: '',
    content: '',
    distributeFor: UserRole.ANY,
    createdById: -1,
    isValid: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    deletedAt: null,
  },
  notices: [],
}

export const notice: Module<NoticeState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
